import React from "react";
import styled from "styled-components";
import ytLogo from "../img/youtube-logo.png";
import HomeIcon from "@mui/icons-material/Home";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import SubscriptionsOutlinedIcon from "@mui/icons-material/SubscriptionsOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import LibraryMusicOutlinedIcon from "@mui/icons-material/LibraryMusicOutlined";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import SportsBasketballOutlinedIcon from "@mui/icons-material/SportsBasketballOutlined";
import MovieOutlinedIcon from "@mui/icons-material/MovieOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import LiveTvOutlinedIcon from "@mui/icons-material/LiveTvOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import SettingsBrightnessOutlinedIcon from "@mui/icons-material/SettingsBrightnessOutlined";
import SlideshowIcon from '@mui/icons-material/Slideshow';
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Container = styled.div`
  flex: 1.4;
  background-color: ${({ theme }) => theme.sidebarBg};
  height: 100vh;
  color: ${({ theme }) => theme.text};
  font-size: 14px;
  overflow-y: scroll;
  overflow-x: hidden;
  position: sticky;
  top: 0;
`;

const Wrapper = styled.div`
  /* padding: 1.2rem 2rem; */
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: bold;
  margin-bottom: 20px;
  padding: 0.8rem 2rem;
  padding-bottom: 0;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  padding: 0.5rem 2rem;

  &:hover {
    background-color: ${({ theme }) => theme.softHr};
  }
`;

const Img = styled.img`
  height: 25px;
`;

const Hr = styled.hr`
  margin: 1rem 0;
  border: 0.5px solid ${({ theme }) => theme.softHr};
`;

const Login = styled.div`
  font-size: 12px;
  padding: 0.8rem 2rem;
`;

const Button = styled.button`
  padding: 5px 15px;
  background-color: transparent;
  border: 1px solid #3ea6ff;
  color: #3ea6ff;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  border-radius: 3px;
  font-weight: 500;
  margin-top: 10px;
`;

const Sidebar = ({ darkMode, setDarkMode }) => {
  const { loggedInUser } = useSelector((state) => state.user);
  return (
    <Container>
      <Wrapper>
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <Logo>
            <Img src={ytLogo} />
            VidTube
          </Logo>
        </Link>
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <Item>
            <HomeIcon />
            Home
          </Item>
        </Link>
        <Link
          to="/trending"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <ExploreOutlinedIcon />
            Explore
          </Item>
        </Link>
        <Link
          to="/subscriptions"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <SubscriptionsOutlinedIcon />
            Subscriptions
          </Item>
        </Link>
        <Hr />
        <Link
          to="/saved"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <VideoLibraryOutlinedIcon />
            Library
          </Item>
        </Link>
         <Link
          to="/history"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <HistoryOutlinedIcon />
            History
          </Item>
        </Link>
         <Link
          to="/myvideos"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <SlideshowIcon />
            My Videos
          </Item>
        </Link>
        <Link
          to="/likedvideos"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <ThumbUpOutlinedIcon />
            Liked Videos
          </Item>
        </Link>
        <Hr />
        {!loggedInUser && (
          <>
            <Link
              to="signin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Login>
                Sign in to like, comment and subscribe.
                <Button>
                  <AccountCircleOutlinedIcon />
                  SIGN IN
                </Button>
              </Login>
            </Link>
            <Hr />
          </>
        )}
        <Link
          to="music"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <LibraryMusicOutlinedIcon />
            Music
          </Item>
        </Link>
        <Link
          to="sports"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <SportsBasketballOutlinedIcon />
            Sports
          </Item>
        </Link>
        
        <Link
          to="movie"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <MovieOutlinedIcon />
            Movies
          </Item>
        </Link>
        <Link
          to="news"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <ArticleOutlinedIcon />
            News
          </Item>
        </Link>
        <Link
          to="gaming"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <SportsEsportsOutlinedIcon />
            Gaming
          </Item>
        </Link>
        <Link
          to="live"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Item>
            <LiveTvOutlinedIcon />
            Live
          </Item>
        </Link>
        <Hr />
        <Item>
          <SettingsOutlinedIcon />
          Settings
        </Item>
        <Item>
          <FlagOutlinedIcon />
          Report
        </Item>
        <Item>
          <HelpOutlineOutlinedIcon />
          Help
        </Item>
        <Item onClick={(e) => setDarkMode((prev) => !prev)}>
          <SettingsBrightnessOutlinedIcon />
          {darkMode ? "Light" : "Dark"} Mode
        </Item>
      </Wrapper>
    </Container>
  );
};

export default Sidebar;
